import { render, staticRenderFns } from "./WriteupForm.vue?vue&type=template&id=44cc851d&"
import script from "./WriteupForm.vue?vue&type=script&lang=js&"
export * from "./WriteupForm.vue?vue&type=script&lang=js&"
import style0 from "./WriteupForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports